module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAxCAMAAABEQrEuAAAAQlBMVEUAAABmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZma1tx8vAAAAFXRSTlMAmZY6NzySPpGq49XGfSkPta9uamigseduAAAAiklEQVRIx82WyRKAIAxDFdwQAbf+/68qXHoOM2Ho/U2TtCxD60rOB4xwImIg4pC/NoSIkmtEkAlHbEEMGVkLsvQnbGoS8lxrf8RD3uAufPv8ueiOkYXZPSM3gryZOOEeD8uHZsWah0pidVAAPh/E+2Smx2rrANOfaUQSfTWiAtB7zv0zpMuHoYf6AM2kEvsoPtnkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/back.png
// module id = U4nQ
// module chunks = 1